import { createReducer } from 'typesafe-actions';
import actions, { DatasetAction } from './actions';
import { DatasetsState } from './types';

export const initState: DatasetsState = { datasets: {}, available: {} };

const reducer = createReducer<DatasetsState, DatasetAction>(initState)
  .handleAction(actions.fetchAvailable.request, (state) => ({
    ...state,
    available: { ...state.available, isFetching: true },
  }))
  .handleAction(actions.fetchAvailable.failure, (state, { payload }) => ({
    ...state,
    available: { ...state.available, fetchError: payload },
  }))
  .handleAction(actions.fetchAvailable.success, (state, { payload }) => ({
    ...state,
    available: {
      ...state.available,
      hasFetched: true,
      isFetching: false,
      list: payload,
    },
  }))
  .handleAction(actions.fetch.request, (state, { payload }) => ({
    ...state,
    datasets: { ...state.datasets, [payload]: { isFetching: true } },
  }))
  .handleAction(actions.add, (state, { payload }) => ({
    ...state,
    available: {
      ...state.available,
      list: [payload, ...(state.available.list || [])],
    },
  }))
  .handleAction(actions.fetch.failure, (state, { payload, meta }) => ({
    ...state,
    datasets: {
      ...state.datasets,
      [meta]: { isFetching: false, fetchError: payload },
    },
  }))
  .handleAction(actions.fetch.success, (state, { payload, meta }) => ({
    ...state,
    datasets: {
      ...state.datasets,
      [meta]: { isFetching: false, hasFetched: true, ...payload },
    },
  }))
  .handleAction(actions.datasetRecordChanges, (state, { payload }) => {
    const dataset = state.datasets[payload.dataset];

    if (!dataset) return state;

    var { data } = dataset;

    switch (payload.action) {
      case 'overwrite':
        data = payload.records;
        break;
      case 'remove':
        data = data?.filter((r) => !payload.records.find((p) => p.id === r.id));
        break;
      default:
        data = payload.records.reduce((updated, rec) => {
          const recIndex = updated.findIndex((d) => d.id === rec.id);

          if (!recIndex) return [...updated, rec];

          return [
            ...updated.slice(0, recIndex),
            rec,
            ...updated.slice(recIndex + 1),
          ];
        }, data!);
        break;
    }

    return {
      ...state,
      loaded: {
        ...state.datasets,
        [payload.dataset]: { ...dataset, data },
      },
    };
  });

export default reducer;
